<template>
    <div class="capture login-block">
        <div class="contain">
            <div class="text">
                <h2>Login As User</h2>
            </div>
            <div class="form">
                <div class="inputs">
                    <div class="input full">
                        <label>
                            Email Address
                            <span class="required">*</span>
                        </label>
                        <input type="email" v-model="email" />
                    </div>
                    <transition name="fade-quick">
                        <button @click="validate()" class="btn">Login</button>
                        <p v-if="feedback" class="error">{{ feedback }}</p>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';
import axios from 'axios';
import Swal from 'sweetalert2';
import { auth, db } from '../firebaseConfig.js';

export default {
    name: 'superAdminLogin',
    data() {
        return {
            email: null,
            status: 'submit',
            feedback: null,
        };
    },
    mounted() {},
    created() {},
    updated() {},
    methods: {
        validate() {
            if (!this.email) {
                Swal.fire(
                    'No email',
                    'Please enter email of user you wish to login as',
                    'error'
                );
            } else this.login();
        },
        login() {
            auth
                .signInWithEmailLink(this.email, window.location.href)
                .then(function(result) {
                    if (result.user) {
                        window.location.reload();
                        return false;
                    }
                })
                .catch(function(error) {
                    return Swal.fire(
                        'Something went wrong, Please try again later',
                        `${error.message}`,
                        'error'
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.loginregister {
    padding-top: 50px;
    .contain {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .form {
            margin-top: 30px;
            @media screen and (max-width: 800px) {
                margin-top: -20px;
            }
        }
    }
}
.capture {
    width: 50%;
    @media screen and (max-width: 800px) {
        width: 100%;
    }
    &.register-block {
        padding-right: 50px;
        @media screen and (max-width: 800px) {
            padding-bottom: 30px;
            padding-right: 0;
        }
    }
    &.login-block {
        height: 100vh;
        padding: 0px 115px;
        margin: 0 auto 0;
        max-width: 900px;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 800px) {
            padding-top: 50px;
            padding-left: 0;
            border-top: 2px solid #eaeaea;
            border-left: none;
        }
    }
    .contain {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 0 !important;
        min-height: auto;
        @media screen and (max-width: 800px) {
            flex-direction: column;
        }
        & > div {
            width: 100%;
            @media screen and (max-width: 800px) {
                width: 100%;
            }
        }
        .inputs {
            @media screen and (max-width: 800px) {
                width: 100%;
                margin-top: 50px;
            }
            .btns {
                display: flex;
                justify-content: flex-end;
                width: 100%;
                .loader {
                    height: 50px;
                    filter: brightness(0.96);
                }
                .success {
                    font-size: 25px;
                    color: #00bf6f;
                    font-weight: bold;
                    span {
                        display: block;
                        color: #132628;
                        font-size: 16px;
                        font-weight: 400;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}

.login-loader {
    height: 50px;
    display: block;
    width: auto !important;
}
</style>
